// extracted by mini-css-extract-plugin
export default {"modal":"ModalCookies_modal__yltcn","bio":"ModalCookies_bio__w2LZT","buttons":"ModalCookies_buttons__X0HUf"};